<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
// import MonitoraTable from './monitora-table'
import appConfig from "@/app.config";
// import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';

import {clientesChart1, clientesChart2 } from "../components/data-simulados";
import exportFromJSON from "export-from-json";
import moment from "moment/moment";
import {
  DxDataGrid,
  DxColumn,
  // DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel,
  DxGrouping,
  DxPager,
  DxFilterRow,
  DxRemoteOperations, DxSummary, DxTotalItem
} from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { exportDataGrid } from 'devextreme/excel_exporter';
import DxButton from "devextreme-vue/button";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Monitoramento XML",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    DxTotalItem, DxSummary,
    DxButton,
    Layout, 
    PageHeader, 
    Loader, 
    Vue3Lottie,
    DxDataGrid,
    DxColumn,
    // DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxPager,
    DxFilterRow,
    DxRemoteOperations
  }, 

  data() {
    return {
      animationJson,
      title: 'Relatórios de WMS',
      items: [
        {
          text: 'WMS',
          href: '/',
        },
        {
          text: 'Relatórios',
          active: true,
        },
      ],
      dataList: [],
      loadingList: true,
      monitorasList: null,
      updating: false,
      periodo: null,
      periodoPesq: false,
      cliChart1: clientesChart1,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      dtIniFiltro: null,
      dtFimFiltro: null,
      detalhedExibition: false,
      submittedPeriodo: null,
      showModalPeriodo: false,
      selectedItems: 0,
    }
  },

  mounted() {
    console.log('mounted monitora-list_0')
    
    this.dtIniFiltro = 
      localStorage.getItem('filtros') ? 
      JSON.parse(localStorage.getItem('filtros')).movdi : 
      moment().startOf('month').format('YYYY-MM-DD')
    this.dtFimFiltro = 
      localStorage.getItem('filtros') ? 
      JSON.parse(localStorage.getItem('filtros')).movdf : 
      moment().endOf('month').format('YYYY-MM-DD')
    this.periodoPesq = 
      localStorage.getItem('filtros') ? 
      !!JSON.parse(localStorage.getItem('filtros')).filterType :
      false
    this.detalhedExibition = 
      localStorage.getItem('filtros') ? 
      !!JSON.parse(localStorage.getItem('filtros')).details :
      false

    let dataAtu = new Date()
    const anoAtu = dataAtu.getFullYear()
    const mesAtu = ("0" + (dataAtu.getMonth())).slice(-2)
    
    this.periodo = anoAtu + '-' + mesAtu
    this.atualizaDataList()
  },

  methods: {

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    atualizarItensSelecionados(e) {
      this.selectedItems = e.selectedRowsData.length;
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Relatórios de WMS: ${dtIniFormated} - ${dtFimFormated}`

      this.totalizadores = this.dataList.totalizadores;
    },

    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
        'filterType': this.periodoPesq,
        'details': this.detalhedExibition,
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    // deletaReg(dataID) {
    //   console.log('deletaReg_pai dataID:')
    //   console.log(dataID)
    //   this.loadingList = true
    //   api.delete(`${getBaseUrl()}api/monitora`, {
    //     params: {
    //       'iddata': dataID
    //     }
    //   }).then((res) => {
    //     console.log('then axios delete')
    //     console.log(res.data)
    //     this.atualizaDataList()
    //     Swal.fire({
    //       position: "top-end",
    //       icon: "success",
    //       title: "Informações excluídas com sucesso!",
    //       showConfirmButton: false,
    //       timer: 1500
    //     })
    //   })
    // },

    relEFDFiscal(){
      console.log('relEFDFiscal')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdfisc`, {
        params: {
          periodo: this.periodo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data[1]
        const fileName = "EFD_Fiscal_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'AB':
          return 'Não Conferido (AB)'
        case 'ES':
          return 'Em Separação (ES)'
        case 'SE':
          return 'Conferido (SE)'
        case 'CA':
          return 'Cancelado (CA)'
        case 'FN':
          return 'Finalizado (FN)'
        case 'EL':
          return 'Elaboração (EL)'
        case 'EQ':
          return 'Embarque (EQ)'
        case null:
          return ''
        case '':
          return ''
      }
      return 'Não Definido'
    },

    relEFDPisCofins(){
      console.log('relEFDPisCofins')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdpiscof`).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data
        const fileName = "EFD_PisCofins_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relResultados(){
      console.log('relResultados')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true

      api.get(`${getBaseUrl()}api/relresults`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_resultados_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },

    confirmaPesq() {
      console.log('titleTime')

      /*const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `Relatórios de Orçamento: ${dtIniFormated} - ${dtFimFormated}`*/
    },


    mudouPeriodo(){
      console.log('mudouPeriodo')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.atualizaDataList()
      this.confirmarPeriodo()
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataRel não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      let details = this.detalhedExibition

      this.dataList = new CustomStore({
        key: "mov_id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df,
            'details': details
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/relwms`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
      this.loadingList = false
    },

    onExportingExcel(e){
      console.log('onExportingExcel')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },
  },
  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

}
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 180px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4" v-if="!updating">
              <div>
                <p><strong>Itens Selecionados: {{ selectedItems }}</strong></p>
              </div>
              <div class="col-12 col-sm-8 d-flex align-items-end">
                <DxButton
                    icon="refresh"
                    hint="Redefinir formatação de tabela para padrão"
                    :on-click="refeFormTable"/>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <DxDataGrid
              ref="dataGridRefKey"
              v-show="!loadingList"
              :data-source="dataList"
              :show-borders="true"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :show-row-lines="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="true"
              @content-ready="carregouGrid"
              @exporting="onExportingExcel"
              @selection-changed="atualizarItensSelecionados"
              :key-expr="'mov_id'"
            >
            <!-- 
              @cell-prepared="onCellPrepared"
              @row-dbl-click="onRowDblClick"
              @content-ready="carregouGrid"
            -->

            <DxRemoteOperations
                :filtering="true"
                :paging="true"
                :sorting="true"
                :summary="false"
                :grouping="false"
                :group-paging="false"
            />


            <!-- <DxColumnChooser :enabled="true"/> -->
            <DxColumnFixing :enabled="true"/>
            <DxFilterRow :visible="true" />

            <DxSelection mode="multiple"/>
            <DxExport
                :enabled="true"
                :allow-export-selected-data="true"/>
            <DxStateStoring
                :enabled="true"
                type="sessionStorage"
                storage-key="strRelWmsList"/>

            <DxGroupPanel :visible="true"/>
            <DxGrouping />

            <!-- <DxColumn
                data-field="id"
                sort-order="desc"
                caption="ID"
                data-type="number"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/> -->

            <DxColumn
                data-field="mov_id"
                caption="ID"
                alignment="right"
                sort-order="desc"
                data-type="number"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            <DxColumn
              :width="330"
              caption="Remetente"
              alignment="center"
              :allowHeaderFiltering="false">
            
              <DxColumn
                data-field="wmsos_remetcnpj"
                caption="CNPJ"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsos_remetnome"
                caption="Nome"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>
            </DxColumn>

            <DxColumn
              :width="330"
              caption="Destinatario"
              alignment="center"
              :allowHeaderFiltering="false">
            
              <DxColumn
                data-field="wmsos_destcnpj"
                caption="CNPJ"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsos_nome"
                caption="Nome"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>
            </DxColumn>

            <DxColumn
              :width="330"
              caption="Nota Fiscal"
              alignment="center"
              :allowHeaderFiltering="false"
              :visible="!detalhedExibition"
              >

              <DxColumn
                data-field="mov_dtemissao"
                caption="Emissao"
                alignment="right"
                data-type="datetime"
                :format="formatDateTime"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                  data-field="mov_created"
                  caption="Data/Hora Criação NF"
                  alignment="right"
                  data-type="datetime"
                  :format="formatDateTime"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="mov_codigo"
                caption="Número NF"
                data-type="text"
                alignment="left"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="mov_valorbrt"
                caption="Valor NF"
                data-type="number"
                :format="formatDecimal"
                alignment="left"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            </DxColumn>

            <DxColumn
              :width="330"
              caption="Produto"
              alignment="center"
              :allowHeaderFiltering="false"
              :visible="detalhedExibition"
              >
              <DxColumn
                data-field="wmsositem_produto"
                caption="Codigo"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsositem_descprod"
                caption="Descricao"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsositem_und"
                caption="Unidade"
                data-type="text"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

              
              <DxColumn
                data-field="wmsositem_vlrunitbrt"
                caption="Valor"
                data-type="number"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            </DxColumn>

            <DxColumn
              :width="330"
              caption="WMS info"
              alignment="center"
              :allowHeaderFiltering="false"
              :visible="!detalhedExibition"
              >            
              <DxColumn
                data-field="wmsos_id"
                caption="Id OS"
                data-type="number"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsos_origem"
                caption="Origem"
                data-type="text"
                alignment="right"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsositem_qtditens"
                caption="Quantidade Itens"
                data-type="number"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                data-field="wmsositem_qtd"
                caption="Quantidade Total"
                data-type="number"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

              <DxColumn
                  data-field="wmsos_status"
                  caption="Status OS"
                  :customize-text="nomeStatus"
                  data-type="text"
                  alignment="right"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="true"/>

              <DxColumn
                  data-field="wmsos_conferente"
                  caption="Último conferente"
                  data-type="text"
                  alignment="right"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="true"/>

              <DxColumn
                  data-field="wmsos_created_at"
                  caption="Data Criação OS"
                  alignment="right"
                  data-type="datetime"
                  :format="formatDateTime"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true"/>

              <DxColumn
                  data-field="wmsos_dtconcl"
                  caption="Data Conclusão OS"
                  alignment="right"
                  data-type="datetime"
                  :format="formatDateTime"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true"/>

            </DxColumn>

              <DxColumn
                  :width="330"
                  caption="Romaneio"
                  alignment="center"
                  :allowHeaderFiltering="false"
                  :visible="!detalhedExibition"
              >

                <DxColumn
                    data-field="romaneio_id"
                    caption="Romaneio Id"
                    data-type="number"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="romaneio_status"
                    caption="Status"
                    :customize-text="nomeStatus"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="wmsosvolume_volume"
                    caption="Volumes"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="wmsosvolume_peso"
                    caption="Peso"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="romaneio_createdat"
                    caption="Data/Hora Criação Romaneio"
                    alignment="right"
                    data-type="datetime"
                    :format="formatDateTime"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="romaneio_updatedat"
                    caption="Última Atualização"
                    alignment="right"
                    data-type="datetime"
                    :format="formatDateTime"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

              </DxColumn>

              <DxSummary>

                <DxTotalItem
                    column="mov_id"
                    summary-type="count"
                    :customize-text="v => v.value.toLocaleString()"/>

                <DxTotalItem
                    column="wmsositem_qtditens"
                    summary-type="sum"
                    :customize-text="v => v.value.toLocaleString()"/>

                <DxTotalItem
                    column="wmsositem_qtd"
                    summary-type="sum"
                    :customize-text="v => v.value.toLocaleString()"/>

                <DxTotalItem
                    column="wmsosvolume_volume"
                    summary-type="sum"
                    :customize-text="v => v.value.toLocaleString()"/>

                <DxTotalItem
                    column="wmsosvolume_peso"
                    summary-type="sum"
                    :customize-text="v => Number(v.value).toFixed(2).replace('.', ',')"/>

                <DxTotalItem
                    column="mov_valorbrt"
                    summary-type="sum"
                    :customize-text="v =>
                      v.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                 "/>

              </DxSummary>


              <DxPager
                :visible="true"
                :show-page-size-selector="true"
                :allowed-page-sizes="[10, 30, 50, 100]"
                :show-navigation-buttons="true"
                :show-info="true"/>


          </DxDataGrid>
          </div>

          <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
            <div class="col-md-12">
              <div class="mb-3">
                <label for="tipooperacao">Selecionar Data Inicial e Final</label>

              </div>
            </div>
            <div class="row">

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="dtIniFiltro">Data Início</label>
                  <input
                      id="dtIniFiltro"
                      v-model="dtIniFiltro"
                      type="date"
                      class="form-control"
                      placeholder="Data Início"
                      :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
                  <div v-if="submittedPeriodo && !dtIniFiltro"
                       class="invalid-feedback">
                    <span >Campo data início obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="dtFimFiltro">Data Final</label>
                  <input
                      id="dtFimFiltro"
                      v-model="dtFimFiltro"
                      type="date"
                      class="form-control"
                      placeholder="Data Final"
                      :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
                  <div v-if="submittedPeriodo && !dtFimFiltro"
                       class="invalid-feedback">
                    <span >Campo data final obrigatória, favor preencher.</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="text-end mt-5">
              <b-button variant="light" @click="showModalPeriodo = false">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
              <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                Confirmar
              </b-button>
            </div>
          </b-modal>

        </div>
      </div>
    </div>

  </Layout>
</template>

